/*$(document).ready(function(){
  const accordionSections = document.querySelectorAll('.accordion_content .section');
  const accordionImageSections = document.querySelectorAll('.accordion_image .section-image');


  if (accordionSections.length > 0) {
    accordionSections[0].querySelector('.section-content').style.maxHeight = accordionSections[0].querySelector('.section-content').scrollHeight + 'px';

    accordionImageSections[0].style.zIndex = 3;
    accordionImageSections[0].style.opacity = 1;
  }
  if (accordionSections) {
    accordionSections.forEach(section => {
      section.addEventListener('click', () => {

        let openedAccordionSection = document.querySelector('.accordion_content .section.open');
        let openedImageSection = document.querySelector('.accordion_image .section-image.open');

        openedImageSection.style.zIndex = '2';
        openedImageSection.style.opacity = '0';

        openedImageSection.classList.remove('open');
        let sectionContent = section.querySelector('.section-content');
        // openedAccordionSection.classList.remove('open');

        if (openedAccordionSection) {
          openedAccordionSection.querySelector('.section-content').style.maxHeight = '0';
          openedAccordionSection.classList.remove('open');
        }

        // setTimeout(() => {
         //   openedAccordionSection.querySelector('.section-content').style.display = 'none';
        //}, "500");


        section.classList.toggle('open');

        sectionContent.style.display = 'block';

        sectionContent.style.maxHeight = sectionContent.scrollHeight + "px";

        openedImageSection.classList.remove('open');

        let image = document.querySelector('.accordion_image .section-image[data-section="' + section.dataset.section + '"]');

        image.style.zIndex = '3';
        image.style.opacity = '1';

        image.classList.add('open')
      })
    })
  }

  document.addEventListener('DOMContentLoaded', function() {
    var modals = document.querySelectorAll('.Modal');
    
    modals.forEach(function(modal) {
      var openBtn = document.querySelector('[aria-controls="' + modal.id + '"]');
      var closeBtn = modal.querySelector('[data-action="close-modal"]');
      var videoIframe = modal.querySelector('iframe');

      // Open modal
      openBtn.addEventListener('click', function(event) {
        event.preventDefault();
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('no-scroll');
        videoIframe.src = videoIframe.getAttribute('data-src'); // Set the iframe src to autoplay the video
      });

      // Close modal
      closeBtn.addEventListener('click', function() {
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        videoIframe.src = ''; // Remove iframe src to stop the video
      });

      // Close modal with ESC key
      document.addEventListener('keyup', function(event) {
        if (event.key === "Escape" && modal.getAttribute('aria-hidden') === 'false') {
          modal.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('no-scroll');
          videoIframe.src = ''; // Stop video
        }
      });
    });
  });

  $(".read-more-button").click(function(){
    $(".product-info__accordion--description summary").click();
  });

});

*/

$(document).ready(function() {
  const accordionSections = document.querySelectorAll('.accordion_content .section');
  const accordionImageSections = document.querySelectorAll('.accordion_image .section-image');

  // Initialize first accordion section
  if (accordionSections.length > 0) {
    const firstContent = accordionSections[0].querySelector('.section-content');
    firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    accordionImageSections[0].style.zIndex = 3;
    accordionImageSections[0].style.opacity = 1;
  }

  // Accordion click logic
  accordionSections.forEach(section => {
    section.addEventListener('click', () => {
      const openedAccordionSection = document.querySelector('.accordion_content .section.open');
      const openedImageSection = document.querySelector('.accordion_image .section-image.open');

      if (openedImageSection) {
        openedImageSection.style.zIndex = '2';
        openedImageSection.style.opacity = '0';
        openedImageSection.classList.remove('open');
      }

      if (openedAccordionSection) {
        openedAccordionSection.querySelector('.section-content').style.maxHeight = '0';
        openedAccordionSection.classList.remove('open');
      }

      section.classList.add('open');
      const sectionContent = section.querySelector('.section-content');
      sectionContent.style.display = 'block';
      sectionContent.style.maxHeight = sectionContent.scrollHeight + "px";

      const image = document.querySelector(`.accordion_image .section-image[data-section="${section.dataset.section}"]`);
      if (image) {
        image.style.zIndex = '3';
        image.style.opacity = '1';
        image.classList.add('open');
      }
    });
  });

  // ✅ Move modal logic directly inside ready()
  const modals = document.querySelectorAll('.Modal');

  modals.forEach(modal => {
    const openBtn = document.querySelector(`[aria-controls="${modal.id}"]`);
    const closeBtn = modal.querySelector('[data-action="close-modal"]');
    const videoIframe = modal.querySelector('iframe');

    if (!openBtn || !closeBtn || !videoIframe) return;

    // Open modal
    openBtn.addEventListener('click', event => {
      event.preventDefault();
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
      videoIframe.src = videoIframe.getAttribute('data-src'); // autoplay video
    });

    // Close modal
    closeBtn.addEventListener('click', () => {
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
      videoIframe.src = ''; // stop video
    });

    // ESC key close
    document.addEventListener('keyup', event => {
      if (event.key === "Escape" && modal.getAttribute('aria-hidden') === 'false') {
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('no-scroll');
        videoIframe.src = '';
      }
    });
  });

  // Read more button
  $(".read-more-button").click(function(){
    $(".product-info__accordion--description summary").click();
  });
});
